export enum ASBVsAction {
  SetASBVs = 'Set',
  SetItems = 'SetItems',
  SetSelectedASBVs = 'SetSelected',
  SetFocussedASBV = 'SetFocussed',
  SetSelectedTooltip = 'SetSelectedTooltip',
  SetSelectedTab = 'SetSelectedTab',
  Reset = 'Reset',
}
